import React, { useEffect, useState } from 'react';
import SongItem from '../SongItem/SongItem';
import NoteTitle from '../NoteTitle/NoteTitle';

const DownloadedSongSuccess = (props) => {
  return (
    <section className='downloadedSongSuccess'>
      <NoteTitle text='הורדת השיר בוצעה בהצלחה'/>
      <p className='success-text'>{props.successText}</p>
      <SongItem isDisplayPlayer={true} playerSize={100} isDetailsFromLeft={true} audio={props.audio} onClickSong={()=> {}}></SongItem>
    </section>
  );
};

export default DownloadedSongSuccess;
